import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'inputConnInvestigationResults',
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        outcome: '',
        invDate: null,
        refuseReason: '',
        comment: ''
      },
      outcomes: [],
      refuseReasons: [],
      minDate: null,
      maxDate: null,
      invDateView: null,

      lang: '',

      disabledInvDates: date => {
        const day = date.getDay();

        if (moment(date).add(1, 'days') < moment(this.appData.minDate).add(1, 'days') ||
          moment(date).add(1, 'days') > moment(this.appData.maxDate).add(1, 'days'))

          return date;
      },
    }
  },
  watch: {
    /*invDateView: function (val) {
      this.appData.invDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    },*/
    "appData.outcome": function (val) {
      if (val == 0)
        this.appData.refuseReason = '0';

      this.appData.outcome = val;
    }
  },
  created() {
    //console.log("appData", this.appData);
    //fix dates
    var t = new Date(this.dataObj.appData.invDate);
    if (t.getHours() == 0) {
      this.dataObj.appData.invDate = moment(this.dataObj.appData.invDate).add(1, 'hours').format();
    }
    else
      this.dataObj.appData.invDate = moment(this.dataObj.appData.invDate).format();

    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('conn_investigation_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.invDateView = this.$options.filters.formatDateDDMMYYY(this.appData.invDate);

        this.outcomes = this.dataObj.appData.outcomes;
        this.refuseReasons = this.dataObj.appData.refuseReasons;
        this.minDate = this.dataObj.appData.minDate;
        this.maxDate = this.dataObj.appData.maxDate;


      });
    },
  },
}
